import React from 'react';
import { useDebounce } from 'react-use';

import { useSearch } from 'src/hooks';
import { Toolbar } from './';

interface ToolbarContainerProps {
  loading?: boolean;
  maxMonth?: string;
  initialSelectedDate?: string;
}

export const ToolbarContainer: React.FC<ToolbarContainerProps> = ({
  loading = false,
  maxMonth,
  initialSelectedDate,
}) => {
  const [searchValue, setSearchValue] = React.useState<string>('');
  const search = useSearch();

  const [selectedMonth, setSelectedMonth] = React.useState<string | null>(
    initialSelectedDate ?? null,
  );

  useDebounce(
    () => {
      if (search?.setSearch) search?.setSearch(searchValue);
    },
    500,
    [searchValue],
  );

  return (
    <Toolbar
      loading={loading}
      setSearchValue={setSearchValue}
      searchValue={searchValue}
      setSelectedMonth={setSelectedMonth}
      selectedMonth={selectedMonth}
      maxMonth={maxMonth}
    />
  );
};
